import ContentLoader from "react-content-loader";

export default {
  ContentLoader,
  Rect: undefined, //fill
  Circle: undefined, //fill
};
